const NODE_ENV = process.env.NODE_ENV || null;
const REGWIZ_URL = process.env.VUE_APP_REGWIZ_URL || null;
const PURCHASE_URL = process.env.VUE_APP_PURCHASE_URL || null;
const TRIAL_URL = PURCHASE_URL.replace('preflight', 'upc/start-trial');
const DEV_GRAPH_URL = process.env.VUE_APP_DEV_GRAPH_URL || null;
const ACCOUNT_URL = process.env.VUE_APP_ACCOUNT_URL || 'https://account.unraid.net';

const DEV_APIKEY = process.env.VUE_APP_DEV_APIKEY || null;
const MIN_API_VER = process.env.VUE_APP_MIN_API_VER || null;
const REC_API_VER = process.env.VUE_APP_REC_API_VER || null;
const MIN_OS_VER = process.env.VUE_APP_MIN_OS_VER || null;
const REC_OS_VER = process.env.VUE_APP_REC_OS_VER || null;
const UPC_VER = process.env.VUE_APP_VERSION || null;

export {
  NODE_ENV,
  REGWIZ_URL,
  PURCHASE_URL,
  TRIAL_URL,
  DEV_GRAPH_URL,
  ACCOUNT_URL,
  DEV_APIKEY,
  MIN_API_VER,
  REC_API_VER,
  MIN_OS_VER,
  REC_OS_VER,
  UPC_VER,
};
